import { atom } from 'jotai'

import store from '@/lib/configs/store-config'

export type ConnectionStatus = 'online' | 'reconnecting' | 'offline' | 'session-check-required'

/** Global connectivity state that drives the reconnecting banner. */
export const connectionStatusAtom = atom<ConnectionStatus>('online')

/** Pure: pick the degraded status from whether the browser still has a network. */
export const computeDegradedStatus = (online: boolean): ConnectionStatus =>
  online ? 'reconnecting' : 'offline'

/** Mark the app degraded — `offline` when the browser reports no network, else `reconnecting`. */
export const markConnectionDegraded = () => {
  const online = typeof navigator === 'undefined' ? true : navigator.onLine !== false
  if (store.get(connectionStatusAtom) === 'session-check-required') return
  store.set(connectionStatusAtom, computeDegradedStatus(online))
}

/** Mark the app recovered. */
export const markConnectionOnline = () => {
  store.set(connectionStatusAtom, 'online')
}
